.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.label {
  font-size: var(--text-sm);
  font-weight: var(--weight-medium);
  color: var(--text-secondary);
}

.required::after {
  content: " *";
  color: var(--intent-danger);
}

.hint {
  font-size: var(--text-sm);
  color: var(--text-muted);
}

.error {
  font-size: var(--text-sm);
  color: var(--intent-danger);
}

.input {
  width: 100%;
  min-height: var(--touch-target);
  padding: 0 var(--space-3);
  background: var(--surface-raised);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-md);
  color: var(--text-primary);
  font-size: var(--text-base);
  transition: border-color var(--duration-fast) var(--ease-out);
}

.input::placeholder {
  color: var(--text-muted);
}

.input:hover:not(:disabled) {
  border-color: var(--text-muted);
}

.input:disabled {
  background: var(--surface-sunken);
  color: var(--text-muted);
  cursor: not-allowed;
}

.invalid {
  border-color: var(--intent-danger);
}

/* Money is typed and read as a column of digits, so it gets the same treatment
   as a rendered figure. */
.numeric {
  font-variant-numeric: tabular-nums;
  font-feature-settings: "tnum" 1;
  text-align: right;
}
